export default __webpack_public_path__ + "static/media/EventsandFestivals.806c1541.webp";